import axios from "axios"
import { handleResponse } from "."
import { BASE_URL } from "../utils/constant"

// Define the expected response types for each endpoint
interface QuoteResponse {
  input: string
  output: string
  minimumOut: string
  swapType: string
  routes: string
  finalPrice: string
}

interface PoolInfoResponse {
  [key: string]: any
}

interface HoldingValueResponse {
  input: string
  output: string
  minimumOut: string
  swapType: string
  routes: string
}

const SERVICE_URL = `${BASE_URL}/quote` // Replace with your actual API base URL

export class QuoteService {
  public static getQuote = async (token: string, amount: string): Promise<QuoteResponse> => {
    return handleResponse<QuoteResponse>(
      axios.get(`${SERVICE_URL}/price`, {
        params: { token, amount },
      }),
    )
  }

  public static getPool = async (poolAddr: string): Promise<PoolInfoResponse> => {
    return handleResponse<PoolInfoResponse>(
      axios.get(`${SERVICE_URL}/pool`, {
        params: { poolAddr },
      }),
    )
  }

  public static getHoldingValue = async (token: string, owner: string): Promise<HoldingValueResponse> => {
    return handleResponse<HoldingValueResponse>(
      axios.get(`${SERVICE_URL}/holdingValue`, {
        params: { token, owner },
      }),
    )
  }
}
